<div class="form-container">
    <div class="form-container__title">{{ formheading }}</div>

    <div class="form-container__form">
        <div [attr.pageID]="pageid"></div>
    </div>

    @if (showtermsandprivacypolicy) {
        <div class="form-container__terms">
            By proceeding, you agree to our
            <a
                nw-link
                [href]="termsUrl"
                target="_blank"
                class="form-container__link"
                rel="noopener noreferrer"
                >Terms</a
            >
            and
            <a
                nw-link
                [href]="privacyPolicyUrl"
                target="_blank"
                class="form-container__link"
                rel="noopener noreferrer"
                >Privacy Policy</a
            >.
        </div>
    }
    @if (showlogin) {
        <div class="form-container__login">
            Already have an account?
            <a
                nw-link
                href="/webapp"
                target="_blank"
                class="form-container__link"
                rel="noopener noreferrer"
                >Login here</a
            >
        </div>
    }
</div>
